import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import { PrinterLgIcon } from '@nv/images/design/printer-lg-icon'
import { useTranslation } from 'react-i18next'
import styles from './ConfirmDisconnect.module.scss'

export const ConfirmDisconnect = ({ confirm, text }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('Confirm Disconnect'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      {
        text: t('buttons.approve'),
        onClick: () => {
          confirm()
          onClose()
        },
      },
    ])
  }, [])
  return (
    <div className={styles['container']}>
      <PrinterLgIcon />
      <span>Are you sure you want to {text}</span>
    </div>
  )
}
